let inject = ['$scope', '$uibModalInstance'];

class OfflineModalController {
  constructor ($scope,$uibModalInstance) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.user = {};
  }
  
  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
  
  selectThird() {
    this.$uibModalInstance.close(this.user);
  }
}

OfflineModalController.$inject = inject;

export default OfflineModalController ;



/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/shared/components/offline-modal/offline-modal.controller.js
 **/